<template>
  <div>
    <div class="columns">
     <div class="column">
       <h2 class="subtitle is-3">{{titleDisplay}}</h2>
     </div>
     <div class="column is-narrow">
       <b-button type="is-primary" class="right" icon-left="refresh" @click="refreshPlanList">Refresh</b-button>
     </div>
   </div>
    <draggable
      v-model="plansArray"
      draggable=".plan"
      handle=".drag-handle"
      ghostClass="drag-ghost"
      dragClass="drag-item"
      @change="update($event)">
      <EditMealPlan
        v-for="(plan, index) in plansArray"
        :key="plan.id"
        :planIn="plan"
        @remove-plan="remove(index)" />
    </draggable>
    <EditMealPlan
      v-if="isAddEnabled"
      isNew
      @add-plan="add($event)" />
  </div>
</template>

<script>
import Draggable from "vuedraggable"
import cloneDeep from 'lodash/cloneDeep'
import db from "@/firebase/db"
import EditMealPlan from "./EditMealPlan.vue"

export default {
  name: 'EditMealPlans',
  components: {
    EditMealPlan,
    Draggable
  },
  props: {
    value: Object,
    title: String,
    maxPlans: Number,
  },
  data() {
    return {
      // local manipulation of the plans list is performed on the array for draggable
      plansArray: null,
    }
  },
  created() {
    var plans = this.value ?? {};

    // flatten the plans map from firebase to an array
    // e.g. from {id: {title: bar}, ...} to [{id: foo, title: bar}, ...]
    var array = Object.keys(plans).map(function(planID) {
      // create new object with the planID included
      var newObj = {id: planID};
      // add all the nested properties
      for (var property in plans[planID]) {
        newObj[property] = plans[planID][property];
      }
      return newObj;
    });

    // set our local array sorted by the plan object's position to bgin with
    this.plansArray = array.sort((a, b) => a.position - b.position);

  },
  computed: {
    titleDisplay() {
      return (this.title != null) ? this.title : "Plans";
    },
    // use to return an object expected by our data structure
    plansObject: {
      get() {
        // convert array to object
        let position = 0;
        return this.plansArray.reduce((accumulator, plan) => {
          plan.position = position;
          accumulator[plan.id] = plan;
          position++;
          return accumulator;
        } ,{});
      }
    },
    isAddEnabled() {
      if (this.plansArray == null) {
        return false;
      }
      return this.plansArray.length < this.maxPlans;
    }
  },
  methods: {
    add(newPlan) {
      // check for duplicate before adding
      if (this.isDuplicate(newPlan)){
        this.$buefy.toast.open({type: 'is-warning', message: `Meal plan is already part of the collection!`})
      }else {
        this.plansArray.push(newPlan);
        this.resetPosition(); // indexes might have changed
        this.$emit('plan-added', newPlan);
        this.$emit('input', this.plansObject);
      }
    },
    remove(index) {
      const removedPlan = this.plansArray[index];
      this.$delete(this.plansArray, index);
      this.resetPosition(); // indexes might have changed
      this.$emit('plan-removed', removedPlan);
      this.$emit('input', this.plansObject);
    },
    update(){
      this.resetPosition(); // indexes have changed
      this.$emit('input', this.plansObject);
    },
    resetPosition(){
      // store the local index as the objects position in firebase
      for (let i = 0; i<this.plansArray.length; i++) {
        this.plansArray[i].position = i;
      }
    },
    isDuplicate(newPlan) {
      return this.plansArray.map(i => { return i.id }).includes(newPlan.id)
    },
    async refreshPlanList() {
      // keep a copy of our plans
      let plans = cloneDeep(this.plansArray);

      // remove all plans
      while(this.plansArray.length > 0){
        this.remove(this.plansArray.length-1);
      }

      // add them back in
      // TODO this is not DRY since the EditMealPlan module does something similar when getting set
      for (let i = 0; i<plans.length; i++) {
        let p = plans[i];

        db.collection('meal_plans')
        .doc(p.id)
        .get()
        .then(snapshot => {
          if (snapshot.exists) {

            let plan = {};
            let fullPlan = snapshot.data();
            plan.id = p.id;
            plan.title = fullPlan.title;
            plan.images = fullPlan.images;
                       
            plan.status = fullPlan.status;
            plan.date = fullPlan.date;
            plan.date_string = fullPlan.date_string;
            plan.backgroundColour = fullPlan.backgroundColour;
            plan.highlightColour = fullPlan.highlightColour;
            plan.recipes_count = Object.keys(fullPlan.recipes).length;
            plan.recipes = fullPlan.recipes;

            plan.position = p.position;

            this.add(plan);
            
          }else {
            console.log(`Warning: Plan does not exist - Skipping!`);
            this.$buefy.notification.open({type: 'is-danger', message: `Warning: Plan does not exist - Skipping!`})
          }
          
        })
        .catch((error) => {
          this.$buefy.notification.open({type: 'is-danger', message: `Error fetching plan: ${error}`})
        });
      }

    }
  }
}
</script>
